module.exports = __webpack_public_path__ + "img/iphoneScreenshotRMRBenefits.8a8424a3.png";